import { APP_INITIALIZER, ErrorHandler, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { environment } from 'src/environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MenuModule } from './components/menu/menu.module';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireDatabaseModule, USE_EMULATOR as USE_DATABASE_EMULATOR } from '@angular/fire/compat/database';
import { AngularFireStorageModule, BUCKET } from '@angular/fire/compat/storage';
import { AngularFireAuthModule, USE_EMULATOR as USE_AUTH_EMULATOR } from '@angular/fire/compat/auth';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { CdkUploadTargetModule } from '@onepointfour-npm/cdk';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AngularFireFunctionsModule, USE_EMULATOR as USE_FUNCTIONS_EMULATOR } from '@angular/fire/compat/functions';
import { AngularFireAuthGuardModule } from '@angular/fire/compat/auth-guard';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { DeleteConfirmationModule } from './components/delete-confirmation/delete-confirmation.module';
import { NetworkLoggerInterceptor } from './interceptors/network-logger.interceptor';
import { AuthErrorInterceptor } from './interceptors/auth-error.interceptor';
import { GlobalErrorHandler } from './services/error.handler';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { USE_EMULATOR as USE_FIRESTORE_EMULATOR, AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { ThemeSelectorComponent } from './components/theme-selector/theme-selector.component';
import { ThemeSelectionDialogComponent } from './components/theme-selection-dialog/theme-selection-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { QuillModule } from 'ngx-quill';

@NgModule({
  declarations: [
    AppComponent,
    ThemeSelectorComponent,
    ThemeSelectionDialogComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    SidebarComponent,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireDatabaseModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    AngularFireFunctionsModule,
    CdkUploadTargetModule,
    MatDialogModule,
    MatSnackBarModule,
    MatIconModule,
    MatButtonModule,
    AngularFireAuthGuardModule,
    HttpClientModule,
    MenuModule,
    DeleteConfirmationModule,
    QuillModule.forRoot(),


    // ServiceWorkerModule.register('combined-sw.js', {
    //   enabled: true,
    //   // Register the ServiceWorker as soon as the application is stable
    //   // or after 30 seconds (whichever comes first).
    //   registrationStrategy: 'registerWhenStable:30000'
    // })
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NetworkLoggerInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthErrorInterceptor,
      multi: true
    },
    { provide: MAT_DATE_LOCALE, useValue: navigator.language },
    {
      provide: ErrorHandler,  // This is the token for Angular's error handling service
      useClass: GlobalErrorHandler  // This is your implementation
    },
    // Firebase Emulator Configuration
    {
      provide: USE_AUTH_EMULATOR,
      useValue: environment.useEmulators ? [`http://${window.location.hostname}:9099`] : undefined
    },
    {
      provide: USE_DATABASE_EMULATOR,
      useValue: environment.useEmulators ? [window.location.hostname, 9000] : undefined
    },
    {
      provide: USE_FIRESTORE_EMULATOR,
      useValue: environment.useEmulators ? [window.location.hostname, 8080] : undefined
    },
    {
      provide: USE_FUNCTIONS_EMULATOR,
      useValue: environment.useEmulators ? [window.location.hostname, 5001] : undefined
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (storage: AngularFireStorage) => () => {
        if (environment.useEmulators) {
          console.log('🔥 Connecting to Firebase Emulators...');
          console.log(`  - Auth: http://${window.location.hostname}:9099`);
          console.log(`  - Database: ${window.location.hostname}:9000`);
          console.log(`  - Firestore: ${window.location.hostname}:8080`);
          console.log(`  - Functions: ${window.location.hostname}:5001`);
          console.log(`  - Storage: ${window.location.hostname}:9199`);
          // Configure Storage emulator
          (storage as any).storage.useEmulator(window.location.hostname, 9199);
        }
      },
      deps: [AngularFireStorage],
      multi: true
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
